import { render } from "./SlideStudioView.vue?vue&type=template&id=61228bc8&ts=true"
import script from "./SlideStudioView.vue?vue&type=script&lang=ts"
export * from "./SlideStudioView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__